import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import CleanFilterButton from '../../../../components/filter/CleanFilterButton'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import ListCounter from '../../../../components/helpers/ListCounter'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'

const UsersCounterBar = () => {
  return (
    <SeparatorWrapper weight={4}>
      <Grid justify="flex-start">
        <Col flex={1}>
          <ListCounter client={accountsClient} entity="users" filterName="UserFilter" fullText bold />
        </Col>

        <Col>
          <CleanFilterButton />
        </Col>
      </Grid>
    </SeparatorWrapper>
  )
}

export default UsersCounterBar
